import React, { memo } from 'react';
import classNames from 'classnames';

import Media from './Media';
import Ban from './ActionButtons/Ban';
import Delete from './ActionButtons/Delete';
import Download from './ActionButtons/Download';
import Favorite from './ActionButtons/Favorite';
import MediaTypeIndicator from './ActionButtons/MediaTypeIndicator';
import Select from './ActionButtons/Select';
import Share from './ActionButtons/Share';
import Description from './Description';
import Authorize from '../Authorize';

import { PHOTOS_WRITE } from '../Authorize/permissions/resources';
import { DELETE_PHOTO, BAN_PHOTO_USER, SELECT_PHOTO } from './permissions';

import './style.scss';

const Snapshot = ({
  children,
  snapshot: {
    _id: snapshotId,
    smallURI: image,
    rawURI: rawImage,
    rawEnhancedURI,
    sharedURI: overlayedImage,
    hidden: banned,
    userId,
    favorite,
    postObj,
    magicshot,
    section,
    row,
    seat,
    date,
    mediaType,
  },
  selected,
  controls,
  sidebar,
  descriptionEnabled,
  imageSrcOverride,
  onClick,
}) => {
  const imageRef = React.useRef();

  const handleMouseEnter = () => {
    if (imageRef.current && mediaType === 'video/mp4' && rawImage) {
      imageRef.current.handleMouseEnter();
    }
  };

  const handleMouseLeave = () => {
    if (imageRef.current && mediaType === 'video/mp4') {
      imageRef.current.handleMouseLeave();
    }
  };

  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
    <div
      role="button"
      onClick={() => onClick(snapshotId)}
      className={classNames('snapshotContainer', { selected, banned, isVideo: mediaType === 'video/mp4' })}
    >
      <Media
        ref={imageRef}
        src={imageSrcOverride ?? image}
        mediaType={mediaType}
        videoSrc={rawEnhancedURI || rawImage}
        descriptionEnabled={descriptionEnabled}
      />

      {children}

      <Description
        show={descriptionEnabled}
        section={section}
        row={row}
        seat={seat}
        date={date}
        mediaType={mediaType}
      />

      <div className="actionPanel" role="group" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <div className="upperControls">
          <Authorize permissions={SELECT_PHOTO}>
            <Select snapshotId={snapshotId} show={controls} />
          </Authorize>
          <Favorite snapshotId={snapshotId} favorite={favorite} show={sidebar} />
          <MediaTypeIndicator mediaType={mediaType} show={!descriptionEnabled} />
          <Share count={postObj.length} show={!descriptionEnabled} />
        </div>

        <div className="bottomControls">
          <Favorite snapshotId={snapshotId} favorite={favorite} show={controls && !magicshot} />
          <Download
            overlayed={overlayedImage}
            raw={rawEnhancedURI || rawImage}
            show={controls || magicshot}
          />
          <Authorize permissions={BAN_PHOTO_USER}>
            <Ban
              banned={banned}
              snapshotId={snapshotId}
              userId={userId}
              show={!magicshot && (controls || sidebar)}
            />
          </Authorize>
          <Authorize or permissions={[PHOTOS_WRITE, DELETE_PHOTO]}>
            <Delete snapshotId={snapshotId} image={image} show={controls || sidebar} />
          </Authorize>
        </div>
      </div>

      <div className="checked" />
    </div>
  );
};

export default memo(Snapshot);
